<template>
	<div class="col-12 rotina-list-toolbar">
		<button type="button" class="btn btn-primary rotina-list-toolbar-mobile" @click="mobileOpen = !mobileOpen" :aria-expanded="String(mobileOpen)">
			<i :class="mobileOpen ? 'fal fa-times' : 'far fa-search'"></i>
		</button>
		<div class="card mb-2 rotina-list-toolbar-card" :class="{ 'is-mobile-open': mobileOpen }">
			<div class="card-body p-12">
				<div class="rotina-list-toolbar-layout">
					<div class="rotina-list-toolbar-actions">
						<button v-if="canCreate" type="button" class="btn btn-primary rotina-list-toolbar-new rotina-shortcut-button" data-shortcut-insert :title="`${newLabel} (Insert)`" @click="$emit('new')">
							<i :class="newIcon" class="me-1"></i><span>{{ newLabel }}</span><span class="rotina-button-shortcut">[INSERT]</span>
						</button>
						<slot name="actions" />
					</div>
					<div class="rotina-list-toolbar-search">
						<div v-if="exibirNavegacaoPeriodo" class="rotina-period-navigation" aria-label="Navegação rápida por mês">
							<button type="button" class="btn rotina-period-arrow" :title="`Ir para ${rotuloMes(-1)}`" aria-label="Mês anterior" @click="alterarMes(-1)"><i class="far fa-chevron-left"></i></button>
							<div class="rotina-period-label" :title="mesFormatado" aria-live="polite">{{ mesCompacto }}</div>
							<button type="button" class="btn rotina-period-arrow" :title="`Ir para ${rotuloMes(1)}`" aria-label="Próximo mês" @click="alterarMes(1)"><i class="far fa-chevron-right"></i></button>
							<button type="button" class="btn rotina-period-current" title="Voltar para o mês atual" aria-label="Voltar para o mês atual" @click="selecionarMesAtual"><i class="far fa-calendar-day"></i><span>Atual</span></button>
						</div>
						<div class="rotina-list-toolbar-quick"><slot name="quick" /></div>
						<button type="button" class="btn btn-primary rotina-list-toolbar-search-button" :title="searchLabel" @click="pesquisar">
							<i class="far fa-search"></i><span class="d-none d-xl-inline ms-1">{{ searchLabel }}</span>
						</button>
						<div v-if="hasAdvanced && modalId" class="rotina-filter-button-group" :class="{ 'is-active': effectiveActiveFilters > 0 }">
							<button type="button" class="btn rotina-list-toolbar-filter-button" :class="effectiveActiveFilters > 0 ? 'btn-warning' : 'btn-outline-primary'" data-bs-toggle="modal" :data-bs-target="`#${modalId}`" @click="abrirModalFiltros">
								<i class="far fa-filter me-1"></i><span>Filtros</span><span v-if="effectiveActiveFilters > 0" class="rotina-filter-count">{{ effectiveActiveFilters }}</span>
							</button>
							<button v-if="effectiveActiveFilters > 0" type="button" class="btn btn-warning rotina-filter-clear-shortcut" title="Limpar todos os filtros avançados" @click="limpar"><span>Limpar</span><i class="far fa-times ms-1"></i></button>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div v-if="hasAdvanced && modalId" class="modal fade" :id="modalId" tabindex="-1" aria-hidden="true">
			<div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable rotina-filter-dialog" :class="{ 'rotina-filter-dialog-wide': wideFilters }">
				<div class="modal-content">
					<div class="modal-header bg-theme text-white">
						<div><h5 class="modal-title mb-0"><i class="far fa-filter me-2"></i>{{ advancedTitle }}</h5><small>Refine a pesquisa usando um ou mais campos.</small></div>
						<button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Fechar" @click="fecharModalFiltros"></button>
					</div>
					<div class="modal-body rotina-filter-body">
						<div class="card mb-0 rotina-filter-card"><div class="card-body"><div class="row g-3 rotina-filter-fields"><slot name="advanced" /></div></div></div>
					</div>
					<div class="modal-footer rotina-filter-footer">
						<div class="me-auto rotina-filter-state" :class="effectiveActiveFilters > 0 ? 'is-active' : ''"><i class="far" :class="effectiveActiveFilters > 0 ? 'fa-check-circle' : 'fa-info-circle'"></i>{{ effectiveActiveFilters > 0 ? `${effectiveActiveFilters} filtro(s) avançado(s) ativo(s)` : 'Nenhum filtro avançado ativo' }}</div>
						<button v-if="effectiveActiveFilters > 0" type="button" class="btn btn-outline-danger" @click="limpar"><i class="far fa-trash me-1"></i>Limpar filtros</button>
						<button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="fecharModalFiltros">Voltar</button>
						<button type="button" class="btn btn-primary" @click="aplicar"><i class="far fa-search me-1"></i>Aplicar filtros</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import $ from 'jquery'

export default {
	name: 'RotinaListaToolbar',
	props: {
		modalId: { type: String, default: '' },
		advancedTitle: { type: String, default: 'Filtros avançados' },
		wideFilters: { type: Boolean, default: false },
		activeFilters: { type: Number, default: 0 },
		canCreate: { type: Boolean, default: false },
		newLabel: { type: String, default: 'Novo' },
		newIcon: { type: String, default: 'far fa-plus' },
		searchLabel: { type: String, default: 'Pesquisar' },
		hasAdvanced: { type: Boolean, default: true },
		showPeriodNavigation: { type: Boolean, default: false },
		periodMonth: { type: String, default: '' },
		periodEnd: { type: String, default: '' }
	},
	data() { return { mobileOpen: false } },
	mounted() { window.addEventListener('keydown', this.tratarInsert) },
	beforeDestroy() { window.removeEventListener('keydown', this.tratarInsert) },
	methods: {
		abrirModalFiltros() {
			if (!this.modalId) return
			$(`#${this.modalId}`).modal('show')
		},
		fecharModalFiltros() {
			if (!this.modalId) return
			$(`#${this.modalId}`).modal('hide')
		},
		mesNormalizado(valor = this.periodMonth) {
			const encontrado = String(valor || '').match(/^(\d{4})-(\d{2})/)
			if (encontrado) return `${encontrado[1]}-${encontrado[2]}`
			const hoje = new Date()
			return `${hoje.getFullYear()}-${String(hoje.getMonth() + 1).padStart(2, '0')}`
		},
		dataDoMes(deslocamento = 0) {
			const [ano, mes] = this.mesNormalizado().split('-').map(Number)
			return new Date(ano, mes - 1 + deslocamento, 1)
		},
		formatarMes(data) {
			const texto = new Intl.DateTimeFormat('pt-BR', { month: 'long', year: 'numeric' }).format(data)
			return texto.charAt(0).toUpperCase() + texto.slice(1)
		},
		rotuloMes(deslocamento) { return this.formatarMes(this.dataDoMes(deslocamento)) },
		emitirPeriodo(data) {
			const ano = data.getFullYear()
			const mesNumero = data.getMonth() + 1
			const mes = `${ano}-${String(mesNumero).padStart(2, '0')}`
			const ultimoDia = new Date(ano, mesNumero, 0).getDate()
			this.$emit('period-change', { mes, inicio: `${mes}-01`, fim: `${mes}-${String(ultimoDia).padStart(2, '0')}` })
			this.mobileOpen = false
		},
		alterarMes(deslocamento) { this.emitirPeriodo(this.dataDoMes(deslocamento)) },
		selecionarMesAtual() { const hoje = new Date(); this.emitirPeriodo(new Date(hoje.getFullYear(), hoje.getMonth(), 1)) },
		pesquisar() { this.$emit('search'); this.mobileOpen = false },
		aplicar() { this.$emit('apply'); this.fecharModalFiltros(); this.mobileOpen = false },
		limpar() { this.$emit('clear') },
		tratarInsert(event) {
			if (!this.canCreate || !event || event.defaultPrevented || this.$el.offsetParent === null) return
			const insert = event.key === 'Insert' || event.code === 'Insert' || event.keyCode === 45
			if (!insert || event.ctrlKey || event.altKey || event.shiftKey || event.metaKey || document.querySelector('.modal.show')) return
			event.preventDefault()
			this.$emit('new')
		}
	},
	computed: {
		effectiveActiveFilters() {
			if (!this.showPeriodNavigation || !this.exibirNavegacaoPeriodo) return this.activeFilters
			const quantidadeCamposPeriodo = [this.periodMonth, this.periodEnd].filter(valor => String(valor || '').trim() !== '').length
			return Math.max(0, this.activeFilters - quantidadeCamposPeriodo)
		},
		exibirNavegacaoPeriodo() {
			if (!this.showPeriodNavigation) return false
			const inicio = String(this.periodMonth || '').slice(0, 10)
			const fim = String(this.periodEnd || '').slice(0, 10)
			if (!inicio && !fim) return true
			if (!/^\d{4}-\d{2}-\d{2}$/.test(inicio) || !/^\d{4}-\d{2}-\d{2}$/.test(fim)) return false
			const mes = inicio.slice(0, 7)
			if (fim.slice(0, 7) !== mes || !inicio.endsWith('-01')) return false
			const [ano, numeroMes] = mes.split('-').map(Number)
			const ultimoDia = String(new Date(ano, numeroMes, 0).getDate()).padStart(2, '0')
			const hoje = new Date()
			const hojeIso = `${hoje.getFullYear()}-${String(hoje.getMonth() + 1).padStart(2, '0')}-${String(hoje.getDate()).padStart(2, '0')}`
			return fim === `${mes}-${ultimoDia}` || (mes === hojeIso.slice(0, 7) && fim === hojeIso)
		},
		mesFormatado() { return this.formatarMes(this.dataDoMes()) },
		mesCompacto() {
			const data = this.dataDoMes()
			const meses = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']
			return `${meses[data.getMonth()]}/${data.getFullYear()}`
		}
	}
}
</script>

<style scoped>
.rotina-list-toolbar-mobile { display:none; height:38px; margin-bottom:.45rem; width:42px; }
.rotina-list-toolbar-card { background:linear-gradient(135deg,#fff 0%,#f7f9fc 100%); border-color:#dfe5ed; box-shadow:0 3px 12px rgba(15,23,42,.045); overflow:visible; }
.rotina-list-toolbar-layout { align-items:center; display:flex; gap:1rem; justify-content:space-between; min-width:0; }
.rotina-list-toolbar-actions,.rotina-list-toolbar-search { align-items:center; display:flex; gap:.5rem; }
.rotina-list-toolbar-actions { flex:0 0 auto; }
.rotina-list-toolbar-search { flex:1 1 auto; justify-content:flex-end; min-width:0; }
.rotina-list-toolbar-quick { flex:0 1 440px; min-width:220px; }
.rotina-list-toolbar-quick::v-deep label { display:none !important; }
.rotina-filter-fields::v-deep label { color:#556175; display:block; font-size:11px; font-weight:700; margin-bottom:.3rem; text-transform:uppercase; }
.rotina-period-navigation { align-items:center; background:#fff; border:1px solid #d8dee8; border-radius:7px; box-shadow:0 1px 3px rgba(15,23,42,.04); display:flex; flex:0 0 auto; height:38px; overflow:hidden; white-space:nowrap; }
.rotina-period-current { border:0; border-left:1px solid #d8dee8; border-radius:0; color:#526072; font-size:11px; font-weight:650; height:36px; min-width:34px; padding:0 .45rem; }
.rotina-period-current span { display:none; }
.rotina-period-current:hover,.rotina-period-current:focus { background:#f4f6f9; color:var(--color-theme,#2b66e8); }
.rotina-period-arrow { border:0; border-radius:0; color:var(--color-theme,#2b66e8); height:36px; min-width:27px; padding:.375rem .25rem; }
.rotina-period-arrow:hover,.rotina-period-arrow:focus { background:color-mix(in srgb,var(--color-theme,#2b66e8) 8%,transparent); color:var(--color-theme,#2b66e8); }
.rotina-period-label { align-items:center; border-left:1px solid #edf0f4; border-right:1px solid #edf0f4; color:#273244; display:flex; font-size:11px; font-weight:750; height:36px; justify-content:center; min-width:72px; padding:0 .3rem; }
.rotina-list-toolbar-new { min-width:170px; white-space:nowrap; }
.rotina-list-toolbar-search-button { min-width:48px; }
.rotina-list-toolbar-filter-button { min-width:120px; white-space:nowrap; }
.rotina-filter-button-group{display:flex;flex:0 0 auto}.rotina-filter-button-group.is-active .rotina-list-toolbar-filter-button{border-bottom-right-radius:0;border-top-right-radius:0}.rotina-filter-clear-shortcut{border-bottom-left-radius:0;border-left:1px solid rgba(71,48,0,.2);border-top-left-radius:0;font-size:11px;font-weight:700;padding-left:.55rem;padding-right:.55rem;white-space:nowrap}
.rotina-filter-count { align-items:center; background:rgba(255,255,255,.9); border-radius:10px; color:#172033; display:inline-flex; font-size:10px; font-weight:800; height:18px; justify-content:center; margin-left:.4rem; min-width:18px; padding:0 .3rem; }
.rotina-filter-dialog { max-width:min(980px,calc(100vw - 24px)); width:calc(100vw - 24px); }
.rotina-filter-dialog .modal-content{border:0;border-radius:10px;box-shadow:0 24px 70px rgba(15,23,42,.26);overflow:hidden}.rotina-filter-body{background:linear-gradient(145deg,#f7f9fc,#eef3f8);padding:14px}.rotina-filter-card{border:1px solid #dfe5ed;border-radius:8px;box-shadow:0 3px 12px rgba(15,23,42,.045)}.rotina-filter-card .card-body{padding:16px}
.rotina-filter-dialog .modal-header small { color:rgba(255,255,255,.78); }
.rotina-filter-state { align-items:center; color:#64748b; display:flex; font-size:12px; gap:.4rem; }
.rotina-filter-state.is-active { color:#ad6500; font-weight:700; }
@media(max-width:991.98px){.rotina-list-toolbar-mobile{align-items:center;display:inline-flex;justify-content:center}.rotina-list-toolbar-card{display:none}.rotina-list-toolbar-card.is-mobile-open{display:block}.rotina-list-toolbar-layout{align-items:stretch;flex-direction:column}.rotina-list-toolbar-actions,.rotina-list-toolbar-search{align-items:stretch;flex-wrap:wrap;justify-content:flex-start}.rotina-period-navigation{flex:1 1 100%;justify-content:flex-end}.rotina-list-toolbar-quick{flex:1 1 100%;min-width:100%}.rotina-list-toolbar-new{flex:1 1 auto}.rotina-list-toolbar-search-button{flex:1 1 calc(50% - .25rem)}.rotina-filter-button-group{flex:1 1 calc(50% - .25rem)}.rotina-filter-button-group .rotina-list-toolbar-filter-button{flex:1 1 auto}}
@media(max-width:575.98px){.rotina-period-navigation{justify-content:space-between}.rotina-period-label{flex:1 1 auto;min-width:76px}.rotina-period-current{padding-left:.45rem;padding-right:.45rem}}
@media(max-width:575.98px){.rotina-filter-footer{align-items:stretch;flex-direction:column}.rotina-filter-state{margin-bottom:.35rem}.rotina-filter-footer .btn{width:100%}}

/* Layout ampliado optativo para filtros das abas de cadastros. */
.rotina-filter-dialog-wide { max-width: min(1240px, calc(100vw - 24px)); }
.rotina-filter-dialog-wide .rotina-filter-fields { display: grid; grid-template-columns: minmax(0, 1fr); gap: 16px; margin: 0; }
.rotina-filter-dialog-wide .rotina-filter-fields::v-deep > * { width: auto; max-width: 100%; min-width: 0; margin-top: 0; padding: 0; }
@media (min-width: 576px) { .rotina-filter-dialog-wide .rotina-filter-fields { grid-template-columns: repeat(2, minmax(0, 1fr)); } }
@media (min-width: 992px) { .rotina-filter-dialog-wide .rotina-filter-fields { grid-template-columns: repeat(3, minmax(0, 1fr)); } }
@media (min-width: 1200px) { .rotina-filter-dialog-wide .rotina-filter-fields { grid-template-columns: repeat(4, minmax(0, 1fr)); } }
</style>
